import {inject, type InjectionKey, provide, reactive, ref} from "vue";

export interface RowSelection {
    get: (key:any) => boolean;
    set: (key:any, state:boolean) => void;
    /** Invert current selection */
    invert: () => void;
    /** Select/unselect all items */
    all: (state:boolean) => void;
    /** Return number of selected items */
    count: (total:number) => number;
}

export const rowSelectionKey = Symbol() as InjectionKey<RowSelection>;

export function injectSelection() {
    const sel = inject(rowSelectionKey);
    if (sel === undefined) throw "Missing row selection (internal bug)";
    return sel;
}

export default function():RowSelection {
    const all = ref<boolean>(false);
    const toggles = reactive(new Set<any>());

    function get(key:any):boolean {
        const a = all.value;
        const b = toggles.has(key);
        return (a && !b) || (!a && b);
    }

    function set(key:any, state:boolean):void {
        if (all.value) {
            if (state) toggles.delete(key);
            else toggles.add(key);
        } else {
            if (state) toggles.add(key);
            else toggles.delete(key);
        }
    }

    function invert():void {
        all.value = !all.value;
    }

    function allSet(state:boolean):void {
        all.value = state;
        toggles.clear();
    }

    function count(total:number):number {
        if (all.value) {
            return total - toggles.size;    // all minus unselected
        } else {
            return toggles.size;
        }
    }

	let selection:RowSelection = {
		get, set, invert, all: allSet, count
	};
	provide(rowSelectionKey, selection);
	return selection;
}
